import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, input } from '@angular/core';
import { API, TagEntityDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-tags',
  templateUrl: './sb-tags.component.html',
  styleUrls: ['./sb-tags.component.scss'],
  standalone: false,
})
export class SbTagsComponent implements OnInit {
  constructor(
    private api: API,
    private errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  _tags: TagEntityDTO[];
  @Input() dtoType: string;
  @Input() dtoId: number;
  @Input() editable: boolean = true;
  @Input() resolveInComponent: boolean;
  tagCount = input<number>(2);

  @Input() set tags(val: TagEntityDTO[]) {
    if (val) {
      this._tags = val;
    } else {
      this._tags = [];
    }
  }

  get tags(): TagEntityDTO[] {
    return this._tags;
  }

  @Output() tagsChange: EventEmitter<TagEntityDTO[]> = new EventEmitter<TagEntityDTO[]>();

  visible: boolean;

  ngOnInit(): void {
    if (this.resolveInComponent) {
      this.api
        .shared_Tag_getTagEntity(this.dtoType, this.dtoId)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            this.tags = data;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
